import { Component, OnInit, Input } from '@angular/core';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { CountriesService } from 'app/components/countries/countries.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { FiltersService } from 'app/components/filters/filters.service';
import { DetailsService } from '../details/details.service';
import { RolesService } from '../roles/roles.service';
import { CONSTANTS } from 'environments/common';

@Component({
  selector: 'app-edit-exhibitor-exhibitor',
  templateUrl: './edit-exhibitor-exhibitor.component.html',
  styleUrls: ['./edit-exhibitor-exhibitor.component.css']
})
export class EditExhibitorExhibitorComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  countries: Array<any> = [];
  sectors: Array<any> = [];
  roles: object = CONSTANTS.ROLES;

  @Input() exhibitorData: object = {};
  @Input() eventName: string = '';
  @Input() selectedOds: Array<any> = [];

  constructor(private exhitorsService: ExhitorsService, private countriesService: CountriesService, public utilsService: UtilsService,
  private filtersService: FiltersService, public detailsService:DetailsService, public rolesService: RolesService) { }



  getExhibitor(getExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getProjection(getExhibitorIn)
      .subscribe((data: object) => {
        this.getExhibitorOk(data);
      },
        error => {
          this.getExhibitorError(error);
        });

  }

  getExhibitorOk(data) {

    this.loader.count--;
    this.exhibitorData['exhibitor'] = data;

    let getExhibitorSectorIn = {
      exhibitorId: this.exhibitorData['exhibitorId']
    }

    this.getExhibitorSector(getExhibitorSectorIn);

    let getExhibitorCataloguePlanIn = {
      exhibitorId: this.exhibitorData['exhibitorId']
    }

    this.getExhibitorCataloguePlan(getExhibitorCataloguePlanIn);

  }

  getExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getCountries() {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.countriesService.getCountries()
      .subscribe((data: object) => {
        this.getCountriesOk(data);
      },
        error => {
          this.getCountriesError(error);
        });

  }

  getCountriesOk(data) {
    this.loader.count--;
    this.countries = data._embedded.countries;
  }

  getCountriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getSectors(getSectorsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getSectors(getSectorsIn)
      .subscribe((data: object) => {
        this.getSectorsOk(data);
      },
        error => {
          this.getSectorsError(error);
        });

  }

  getSectorsOk(data) {
    this.loader.count--;
    this.sectors = data._embedded.sectors;
  }

  getSectorsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  removeBrand(brand:string):void {
    this.exhibitorData['exhibitor']['brand'].trim();
    const arrayCatalogueBrands = this.exhibitorData['exhibitor']['brand'].split(',');
    const index = arrayCatalogueBrands.indexOf(brand);
    if (index > -1) {
      arrayCatalogueBrands.splice(index, 1);
    }
    this.exhibitorData['exhibitor']['brand'] = arrayCatalogueBrands.join(',');
  }


  getExhibitorSector(getExhibitorSectorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getExhibitorSector(getExhibitorSectorIn)
      .subscribe((data: object) => {
        this.getExhibitorSectorOk(data);
      },
        error => {
          this.getExhibitorSectorError(error);
        });

  }

  getExhibitorSectorOk(data) {

    this.loader.count--;
    this.exhibitorData['exhibitor']['sectorId'] = data['id'];


  }

  getExhibitorSectorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getExhibitorCataloguePlan(getExhibitorCataloguePlanIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getExhibitorCataloguePlan(getExhibitorCataloguePlanIn)
      .subscribe((data: object) => {
        this.getExhibitorCataloguePlanOk(data);
      },
        error => {
          this.getExhibitorCataloguePlanError(error);
        });

  }

  getExhibitorCataloguePlanOk(data) {

    this.loader.count--;
    this.exhibitorData['exhibitor']['cataloguePlanId'] = data['id'];
    this.exhibitorData['imageExhibitorLimit'] = data['imageExhibitorLimit'];
    this.exhibitorData['imageProductLimit'] = data['imageProductLimit'];

  }

  getExhibitorCataloguePlanError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  ngOnInit() {

    let getExhibitorIn = {
      exhibitorId: this.exhibitorData['exhibitorId'],
      projection: 'detail'
    }

    this.getExhibitor(getExhibitorIn);

    this.getCountries();

    let getSectorsIn = {
      eventName: this.exhibitorData['eventName']
    };

    this.getSectors(getSectorsIn);



  }

}
